import React, { Component } from "react";

export default class Sidebar extends Component {
  render() {
    return (
      <div>
        <div>
          <nav
            href="#navbar"
            className="js-colorlib-nav-toggle colorlib-nav-toggle"
            data-toggle="collapse"
            data-target="#navbar"
            aria-expanded="false"
            aria-controls="navbar"
          >
            <i />
          </nav>
          <aside
            style={{ backgroundColor: "#fff" }}
            id="colorlib-aside"
            className="border js-fullheight"
          >
            <div className="text-center">
              <div
                className="author-img"
                style={{
                  backgroundImage: "url(images/profile_casa.jpeg)",
                  backgroundSize: "cover",
                }}
              />
              <h1 id="colorlib-logo">
                <a href="index.html" style={{ color: "rgb(67, 197, 158)" }}>
                  Mohamed Jadib
                </a>
              </h1>
              <span className="email" style={{ fontSize: "18px" }}>
                <i className="icon-mail" style={{ marginRight: "5px" }}></i>
                jadibdev@gmail.com
              </span>
            </div>
            <nav id="colorlib-main-menu" role="navigation" className="navbar">
              <div id="navbar" className="collapse">
                <ul>
                  <li className="active">
                    <a href="#home" data-nav-section="home">
                      Introduction
                    </a>
                  </li>
                  <li>
                    <a href="#about" data-nav-section="about">
                      Education
                    </a>
                  </li>
                  {/*<li><a href="#" data-nav-section="projects">Projects</a></li>
                  <li><a href="#" data-nav-section="blog">Blog</a></li>*/}
                  <li>
                    <a href="#timeline" data-nav-section="timeline">
                      PORTFOLIO
                    </a>
                  </li>
                </ul>
              </div>
            </nav>
            <nav id="colorlib-main-menu">
              <ul>
                <li>
                  <a
                    href="https://github.com/jadibdev"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="icon-github"></i>
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.linkedin.com/in/mohamed-jadib-942a5041/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="icon-linkedin2" />
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.instagram.com/m_jadib/?hl=en"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="icon-instagram" />
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.facebook.com/muhammadjadib"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="icon-facebook2" />
                  </a>
                </li>
                <li>
                  <a
                    href="https://twitter.com/MohamedJadib"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="icon-twitter2" />
                  </a>
                </li>
              </ul>
            </nav>
            <div className="colorlib-footer">
              <p style={{ fontSize: "14px", paddingTop: "20px" }}>
                <small>
                  Made with <i className="icon-heart" aria-hidden="true" /> and{" "}
                  <i className="icon-beer" aria-hidden="true"></i>
                  <br></br>
                  Mohamed Jadib
                  <br /> 2837 24th st <br /> San Francisco, CA
                </small>
              </p>
            </div>
          </aside>
        </div>
      </div>
    );
  }
}
